var _defs, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapDepot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #152740;\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-3 {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #39629d;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #fff;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12,1.1c-3.8,0-6.9,3.1-6.9,6.9s3.1,6.9,6.9,6.9,6.9-3.1,6.9-6.9S15.8,1.1,12,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.8,1c-1.2-.7-2.5-1-3.8-1C7.6,0,4,3.6,4,8s.3,2.6,1,3.8l6.6,11.9c.1.2.4.3.7.2l.2-.2,6.5-11.9c2.1-3.9.6-8.7-3.2-10.8ZM12,14.9c-3.8,0-6.9-3.1-6.9-6.9S8.2,1.1,12,1.1s6.9,3.1,6.9,6.9-3.1,6.9-6.9,6.9Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M8.4,10.5h.9v-3.7h5.6v3.7h.9v-5l-3.7-1.5-3.7,1.5v5ZM7.4,11.5v-6.5l4.7-1.9,4.7,1.9v6.5h-2.8v-3.7h-3.7v3.7h-2.9ZM10.7,11.5v-.9h.9v.9h-.9ZM11.6,10.1v-.9h.9v.9h-.9ZM12.6,11.5v-.9h.9v.9h-.9ZM9.3,6.8h5.6s-5.6,0-5.6,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapDepot);
export default __webpack_public_path__ + "static/media/map-depot.76d1a1da3be9c6a50fbf08451d10f7b2.svg";
export { ForwardRef as ReactComponent };